<template>
  <li v-if="hasAnyValues" class="filter-item">

    <div class="title" :style="[{backgroundColor}]">{{filterKeys[filter.key].title}}</div>

    <div>
      <div v-if="includeValues && includeValues.length">
        <span class="descriptor">Include:</span>
        <span v-for="(value, index) in includeValues" :key="`inc-${value}-${index}`">
          {{value.label || value}}<span v-if="index !== includeValues.length - 1" class="comma">,</span>
        </span>
      </div>

      <div v-if="excludeValues && excludeValues.length">
        <span class="descriptor">Exclude:</span>
        <span v-for="(value, index) in excludeValues" :key="`inc-${value}-${index}`">
          {{value.label || value}}<span v-if="index !== excludeValues.length - 1" class="comma">,</span>
        </span>
      </div>

      <div v-if="filter.value && filter.value !== ''">
        {{ filter.value }}
      </div>

    </div>
  </li>
</template>

<script>
import { filterKeys } from "../../../../config/bool-const";

export default {
  name: "FilterItem",
  props: {
    filter: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      filterKeys: filterKeys
    }
  },

  computed: {
    languages() { return this.$store.state.languages.languages.data },
    locations() { return this.$store.state.countries.countries.data },
    languagesData() { return this.languages && this.languages.data },
    locationsData() { return this.locations && this.locations.data && this.locations.data.data },
    filterKey() { return Object.values(this.filter)[0] } ,
    values() { return this.filter.values },

    backgroundColor() { return (this.filterKeys && this.filterKeys[this.filter.key] && this.filterKeys[this.filter.key].color) || '#6B7280' },

    excludeValuesKey() { return Object.keys(this.values).find(key => key.toLowerCase().includes('exclude'))},
    includeValuesKey() { return Object.keys(this.values).find(key => key.toLowerCase() !== this.excludeValuesKey)},

    excludeValues () {
      let values =  (this.values[this.excludeValuesKey] || []).filter(value => value && value !== "")
      if(this.filterKey === 'locations' && values.length) values = this.mapLocationCodesToNames(values, this.locationsData, 'alpha_2_code')
      if(this.filterKey === 'languages' && values.length) values = this.mapLocationCodesToNames(values, this.languagesData, 'alpha_2_code')
      return values
    },

    includeValues () {
      let values =  (this.values[this.includeValuesKey] || []).filter(value => value  && value !== "")
      if(this.filterKey === 'locations' && values.length) values = this.mapLocationCodesToNames(values, this.locationsData, 'alpha_2_code')
      if(this.filterKey === 'languages' && values.length) values = this.mapLocationCodesToNames(values, this.languagesData, 'alpha_2_code')
      return values
    },

    hasAnyValues() {
      return this.values.length || [...this.includeValues, ...this.excludeValues].length
    }
  },

  methods: {
    mapLocationCodesToNames(values, sourceMap, key) {
        return  values.map(value => {
          const mappedItem = sourceMap && sourceMap.find(item => item[key] === value)
          return mappedItem ? mappedItem.name : value
        })
      }

  }
}
</script>